<template>
  <div v-rect-loading="loading" class="channel-editor-page">
    <div class="channel-editor-header">
      <div class="channel-editor-title">{{ titleLabel }}</div>
    </div>
    <div class="form-container">
      <WrappedFrom
        ref="form"
        class="channel-management-info"
        label-width="220px"
        :model="channelData"
        :formLines="formLines"
      >
      </WrappedFrom>
      <div class="bottom-btn-group">
        <el-button class="cancel-btn" @click="handleCancel">{{ cancelBtnLabel }}</el-button>
        <el-button class="save-btn" @click="handleSave">{{ saveBtnLabel }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import WrappedFrom from '@/components/formEditor/wrappedForm.vue'
import { selectLabelI18n } from '@/i18n'
import { mixedRouterPush } from '@/router/routes'
import { mapActions } from 'vuex'

export default {
  components: {
    WrappedFrom
  },
  props: {

  },
  data () {
    return {
      i18nPrefix: 'admin.company.sourceChannelManagement',
      loading: false,
      channelData: {}
    }
  },
  computed: {
    isEditMode () {
      return this.$route.meta.isEditMode
    },
    titleLabel () {
      return this.$t(`${this.i18nPrefix}${this.isEditMode ? '.label.channelEdit' : '.label.channelAdd'}`)
    },
    cancelBtnLabel () {
      return selectLabelI18n(this, 'cancelBtn', 'common.btn.cancel')
    },
    saveBtnLabel () {
      return selectLabelI18n(this, 'saveBtn', 'common.btn.save')
    },
    formLines () {
      const lines = {
        cn_name: {
          label: this.$t(`${this.i18nPrefix}.label.chineseName`),
          placeholder: this.$t(`${this.i18nPrefix}.placeholder.chineseName`),
          rules: [{ required: true, message: this.$t(`${this.i18nPrefix}.message.required`), trigger: 'blur' }]
        },
        name: {
          label: this.$t(`${this.i18nPrefix}.label.englishName`),
          placeholder: this.$t(`${this.i18nPrefix}.placeholder.englishName`),
          rules: [{ required: true, message: this.$t(`${this.i18nPrefix}.message.required`), trigger: 'blur' }]
        }
      }
      return lines
    },
    form () {
      const form = this.$refs.form
      return form
    }
  },
  created () {

  },
  methods: {
    ...mapActions('sourceCode', ['saveSourceChannel']),
    async submit () {
      const resp = await this.saveSourceChannel(this.channelData)
      if (resp) {
        this.$message.success(this.$t(`${this.i18nPrefix}.message.optionSuccess`))
        this.$router.replace({ path: '/v-admin/source-channel/management/channel', query: this.$route.query })
      }
    },
    async handleSave () {
      if (this.loading) {
        return
      }
      this.loading = true
      try {
        let result = false
        result = await this.form.submit()
        if (!result) {
          return
        }
        await this.submit()
      } finally {
        this.loading = false
      }
    },
    handleCancel () {
      const backUrl = this.$route.query.back
      if (backUrl) {
        mixedRouterPush(this.$route.query.back)
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.channel-editor-page {
  .channel-editor-header {
    display: flex;
    border-bottom: 1px solid #e4e7ed;

    .channel-editor-title {
      padding-top: 4px;
      padding-bottom: 18px;
      line-height: 25px;
      font-size: 18px;
      font-weight: 500;
      color: #303133;
    }
  }

  .form-container {
    width: 606px;
    margin: 30px auto 0;

    .bottom-btn-group {
      display: flex;
      justify-content: flex-end;

      .el-button {
        padding: 8px 28px;
        border-radius: 2px;
        line-height: 22px;
        font-size: 16px;
        font-weight: 500;
        color: #0096cc;

        &:last-child {
          margin-left: 24px;
          margin-right: 0;
          background: #0096cc;
          border-color: #0096cc;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
